// libraries
import { get } from "@cloudspire/legacy-shared/src/libraries";

// normalizers
import parseCommentListData from "./parseCommentListData";

const parseCommentListResponse = ({ rawResponse, extra }) => {
  return {
    data: parseCommentListData({
      rawResponseData: get(rawResponse, "data", []),
    }),
    meta: {
      currentPage: Number(get(extra, ["query", "page"], 1)),
      itemPerPage: Number(get(extra, ["query", "per_page"], 15)),
      itemCount: Number(get(rawResponse, ["meta", "nb_results"], 0)),
    },
  };
};

export default parseCommentListResponse;
